/* =====================================================
   Arte Taxco — PDP Anillos (pdp-anillo.js)
   1. Size guide modal (open / close / keyboard / focus trap)
   2. Mobile sticky CTA (IntersectionObserver)
   3. GA4 ecommerce events (view_item, add_to_cart)
   ===================================================== */

(function () {
  'use strict';

  /* ── 1. SIZE GUIDE ──────────────────────────────── */
  const modal   = document.getElementById('SizeGuideModal');
  const openers = document.querySelectorAll('[data-size-guide-open]');
  const closers = document.querySelectorAll('[data-size-guide-close]');
  let lastFocus = null;

  function openSizeGuide() {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    const closeBtn = modal.querySelector('.pdp-size-guide__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeSizeGuide() {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  openers.forEach(function (el) {
    el.addEventListener('click', openSizeGuide);
  });

  closers.forEach(function (el) {
    el.addEventListener('click', closeSizeGuide);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) {
      closeSizeGuide();
    }
  });

  /* ── 2. MOBILE STICKY CTA ──────────────────────── */
  const stickyBar = document.querySelector('.pdp-sticky-cta');
  const stickyBtn = document.querySelector('.pdp-sticky-cta__btn');
  const mainForm  = document.querySelector('[data-type="add-to-cart-form"]');
  const mainBtn   = document.getElementById('ProductSubmitButton-main')
                    || document.querySelector('.product-form__submit');

  if (stickyBar && mainBtn && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      });
    }, { threshold: 0.2 });

    observer.observe(mainBtn);
  }

  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      if (mainBtn) {
        mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { mainBtn.focus(); }, 400);
      }
    });
  }

  /* Sync sticky CTA price with selected variant */
  const stickyPrice = document.querySelector('.pdp-sticky-cta__price');
  if (stickyPrice) {
    document.addEventListener('variant:changed', function (e) {
      if (e.detail && e.detail.variant) {
        var price = (e.detail.variant.price / 100).toLocaleString('es-MX', {
          style: 'currency', currency: 'MXN'
        });
        stickyPrice.textContent = price;
      }
    });
  }

  /* ── 3. GA4 ECOMMERCE EVENTS ────────────────────── */
  var productData = null;

  try {
    var metaEl = document.getElementById('pdp-product-meta');
    if (metaEl) productData = JSON.parse(metaEl.textContent);
  } catch (e) {}

  function pushEvent(eventName, params) {
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: eventName, ecommerce: params });
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  }

  /* view_item — dispara al cargar la PDP */
  if (productData) {
    pushEvent('view_item', {
      currency: productData.currency,
      value: productData.price,
      items: [{
        item_id:   productData.sku || productData.id,
        item_name: productData.title,
        price:     productData.price,
        item_brand: 'Arte Taxco',
        item_category: productData.type,
        item_variant:  productData.variant_title
      }]
    });
  }

  /* add_to_cart — dispara al enviar el formulario de producto */
  if (mainForm && productData) {
    mainForm.addEventListener('submit', function () {
      var selectedVariantInput = mainForm.querySelector('[name="id"]');
      var variantId = selectedVariantInput ? selectedVariantInput.value : '';

      pushEvent('add_to_cart', {
        currency: productData.currency,
        value: productData.price,
        items: [{
          item_id:    productData.sku || productData.id,
          item_name:  productData.title,
          price:      productData.price,
          item_brand: 'Arte Taxco',
          item_category: productData.type,
          item_variant:  productData.variant_title,
          variant_id:    variantId,
          quantity: 1
        }]
      });
    });
  }
})();
